// extracted by mini-css-extract-plugin
module.exports = {"avatar":"AvatarWithVerifiedBadge_avatar__1QAzD","badge":"AvatarWithVerifiedBadge_badge__LU_sN","sending":"AvatarWithVerifiedBadge_sending__hlLjK"};